import Library from './Library'

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    fontAwesome: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      icon: null,
    }
  },

  computed: {
    isFontAwesomeIcon() {
      return this.fontAwesome.length !== 0
    },

    fontAwesomeIcon() {
      return this.fontAwesome
    },
  },

  created() {
    if (this.isFontAwesomeIcon) {
      this.icon = this.fontAwesomeIcon
    } else {
      this.icon = Library[this.name]
    }
  },
}
